import { useRef, useState } from "react";
import { Upload, Link2, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const ImageUpload = ({ value, onChange, label = "Image", testid = "image" }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = () => inputRef.current?.click();

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) return toast.error("Choisissez un fichier image.");
    setBusy(true);
    try {
      const url = await api.uploadImage(file);
      onChange(url);
      toast.success("Image téléversée.");
    } catch {
      toast.error("Échec du téléversement.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <label className="text-sm font-medium text-slate-700">{label}</label>
      <div className="mt-1.5 flex items-start gap-3">
        <div className="relative">
          <button
            type="button"
            data-testid={`${testid}-upload-btn`}
            onClick={pick}
            disabled={busy}
            className="grid place-items-center w-20 h-20 rounded-2xl border-2 border-dashed border-[#012141]/25 bg-white overflow-hidden hover:border-[#C89A3E] transition-colors"
          >
            {value ? (
              <img src={value} alt={label} className="w-full h-full object-cover" />
            ) : busy ? (
              <Loader2 size={20} className="animate-spin text-[#C89A3E]" />
            ) : (
              <Upload size={18} className="text-slate-400" />
            )}
          </button>
          {value && (
            <button
              type="button"
              data-testid={`${testid}-clear-btn`}
              onClick={() => onChange("")}
              className="absolute -top-2 -right-2 grid place-items-center w-6 h-6 rounded-full bg-red-500 text-white shadow"
            >
              <X size={12} />
            </button>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <button
            type="button"
            onClick={pick}
            disabled={busy}
            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full bg-[#012141] text-white text-xs font-semibold hover:bg-[#00172E] disabled:opacity-50"
          >
            {busy ? <Loader2 size={13} className="animate-spin" /> : <Upload size={13} />} Téléverser
          </button>
          <div className="mt-2 relative">
            <Link2 size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              data-testid={`${testid}-url-input`}
              value={value || ""}
              onChange={(e) => onChange(e.target.value)}
              placeholder="ou coller une URL…"
              className="w-full pl-8 pr-2 py-1.5 rounded-lg border border-[#012141]/15 text-xs focus:outline-none focus:border-[#C89A3E]"
            />
          </div>
        </div>
        <input ref={inputRef} type="file" accept="image/*" onChange={onFile} className="hidden" data-testid={`${testid}-file-input`} />
      </div>
    </div>
  );
};
